import { storageGet, storageSet } from '../libs/localStorage';

export default async (productId, amount = 1) => {
  const basketItems = storageGet('basketItems');
  if (basketItems) {
    const basketItemsArray = Object.values(basketItems);
    const productsIds = basketItemsArray.map((el) => el.PRODUCT_ID);
    if (productsIds.includes(`${productId}`)) return false;
  }

  const formData = new FormData();

  formData.append('prop[0]', '0');
  formData.append('ajax_basket', 'Y');
  formData.append('id', `${productId}`);
  formData.append('quantity', `${amount}`);

  const data = new URLSearchParams(formData);

  try {
    const rawResponse = await fetch('/local/ajax/basket/sendToBasket.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
    });

    const responseToString = await rawResponse.text();
    const response = JSON.parse(responseToString);

    storageSet({ key: 'basketItems', value: response.basketItems });
    window.basketUpdate();

    return true;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return false;
  }
};
